module.exports = __webpack_public_path__ + "media/images/portal/finish-img-fa01ee81c5ebc51f710c2585a060b848.png";